// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { usePerformHapticFeedback, HapticsStyle } from '../utils/haptics/usePerformHapticFeedback';

// Components
import { Icon } from './editor/dependencies';

// Styles
import './Checkbox.scss';

const Checkbox = (props) => {
    const { error, checked, onClick, ...otherProps } = props;
    const performHapticFeedback = usePerformHapticFeedback();

    const [animate, setAnimate] = React.useState(false);

    React.useEffect(() => {
        setAnimate(true);
        setTimeout(() => {
            setAnimate(false);
        }, 250);
    }, [checked]);

    const handleOnClick = (event) => {
        performHapticFeedback(HapticsStyle.ImpactLight);

        if (onClick) {
            onClick(event);
        }
    };

    return (
        <div
            contentEditable={false}
            className={classNames('Checkbox', { error, checked, animate })}
            onClick={handleOnClick}
            {...otherProps}
        >
            <Icon name="checkbox-animated" />
        </div>
    );
};

Checkbox.propTypes = {
    onClick: PropTypes.func,
    checked: PropTypes.bool,
    error: PropTypes.bool,
};

export default Checkbox;
